module.exports = __webpack_public_path__ + "img/ecoprojectDetail.84dcae90.jpeg";